import { z } from 'zod';
import {
  coordinateSchema,
  drawingSchema,
  organisationSchema,
  patientSchema,
  signTypeSchema,
  unitStatusSchema,
} from './scenario';
import { triageCategorySchema } from './triage';

export const eventPayloadSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('SignPlaced'),
    signId: z.string().min(1),
    signType: signTypeSchema,
    position: coordinateSchema,
    label: z.string().optional(),
    organisation: organisationSchema.optional(),
  }),
  z.object({ type: z.literal('SignMoved'), signId: z.string().min(1), position: coordinateSchema }),
  z.object({ type: z.literal('SignRemoved'), signId: z.string().min(1) }),
  z.object({
    type: z.literal('UnitStatusChanged'),
    unitId: z.string().min(1),
    status: unitStatusSchema,
  }),
  z.object({
    type: z.literal('ReinforcementRequested'),
    requestId: z.string().min(1),
    signType: signTypeSchema,
    count: z.number().int().positive(),
    text: z.string().optional(),
  }),
  z.object({ type: z.literal('ReinforcementArrived'), requestId: z.string().min(1) }),
  z.object({
    type: z.literal('PatientTriaged'),
    patientId: z.string().min(1),
    category: triageCategorySchema,
  }),
  z.object({
    type: z.literal('PatientTransferred'),
    patientId: z.string().min(1),
    destination: z.string(),
  }),
  z.object({
    type: z.literal('SurgicalIndicationSet'),
    patientId: z.string().min(1),
    indicated: z.boolean(),
  }),
  z.object({
    type: z.literal('TransportReleaseSet'),
    patientId: z.string().min(1),
    released: z.boolean(),
  }),
  z.object({ type: z.literal('PatientAdded'), patient: patientSchema }),
  z.object({ type: z.literal('InjectTriggered'), injectId: z.string().min(1) }),
  z.object({ type: z.literal('DrawingAdded'), drawing: drawingSchema }),
  z.object({ type: z.literal('DrawingRemoved'), drawingId: z.string().min(1) }),
  z.object({ type: z.literal('NoteAdded'), text: z.string().min(1) }),
]);
export type EventPayload = z.infer<typeof eventPayloadSchema>;
export type EventType = EventPayload['type'];

export const eventSchema = z.intersection(
  eventPayloadSchema,
  z.object({ id: z.string().min(1), time: z.number().int().nonnegative() }),
);
export type Event = EventPayload & { id: string; time: number };
